__turbopack_context__.v({
  "Drawer": "cookie-drawer-module__FJdp5a__Drawer",
  "DrawerInner": "cookie-drawer-module__FJdp5a__DrawerInner",
  "open": "cookie-drawer-module__FJdp5a__open",
});
